@switch ($band()) {

  <!-- Gentlest nudge: the shared notice geometry with a neutral treatment. -->
  @case ('advisory') {
    <div class="guard-clip">
      <div class="guard-notice guard-notice-advisory" role="status">
        <span class="guard-glow" aria-hidden="true"></span>
        <span class="guard-copy">
          <span class="guard-title">You’ve been talking here for a while</span>
          <span class="guard-body">A new chat will feel fresher and use your allowance more efficiently.<button type="button" class="guard-action" (click)="newChat.emit()">Start a new <span class="guard-action-end">chat <i class="fa-regular fa-arrow-right" aria-hidden="true"></i></span></button></span>
        </span>
        <button type="button" class="guard-dismiss" (click)="dismiss.emit()" aria-label="Dismiss this notice">
          <i class="fa-regular fa-xmark" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  }

  <!-- Firmer nudge: the same geometry in warm amber, still dismissible and still non-blocking. -->
  @case ('approaching') {
    <div class="guard-clip">
      <div class="guard-notice guard-notice-approaching" role="status">
        <span class="guard-glow" aria-hidden="true"></span>
        <span class="guard-copy">
          <span class="guard-title">This chat is getting a little long</span>
          <span class="guard-body">Start a new chat soon so you don’t hit the conversation limit.<button type="button" class="guard-action" (click)="newChat.emit()">Start a new <span class="guard-action-end">chat <i class="fa-regular fa-arrow-right" aria-hidden="true"></i></span></button></span>
        </span>
        <button type="button" class="guard-dismiss" (click)="dismiss.emit()" aria-label="Dismiss this notice">
          <i class="fa-regular fa-xmark" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  }

  <!-- Terminal state: the same notice typography, sized and shaped as the read-only composer it
       stands in for. Solid neutral grey, no dismiss, no danger colour. -->
  @case ('blocked') {
    <div class="guard-notice guard-terminal" role="status">
      <span class="guard-glow" aria-hidden="true"></span>
      <span class="guard-copy">
        <span class="guard-title">You’ve reached this chat’s limit</span>
        <span class="guard-body">The conversation stays available to read and copy. Sending and uploading are paused here.<button type="button" class="guard-action" (click)="newChat.emit()">Start a new <span class="guard-action-end">chat <i class="fa-regular fa-arrow-right" aria-hidden="true"></i></span></button></span>
      </span>
    </div>
  }
}
